<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import Loader from "@/components/widgets/preloader";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Cash Out",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Cash Out",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Cash Out",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "amt_field",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "givenTo",
          sortable: true,
          label: "GIVEN TO",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "mode_field",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "recordedby.name",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "DATE/TIME",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // Value from user input for adding category
      data: {
        amount: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
        givento: "",
        reason: "",
      },
      // edit category
      editdata: {
        amount: "",
        givento: "",
        id: "",
        mode: "",
        reason: "",
        date: "",
      },
      // make inputs required
      amountError: "",
      modeError: "",
      // delete
      deletedata: {
        amount: "",
        id: "",
      },
      filters: {
        dto: moment(new Date()).format("YYYY-MM-DD"),
        dfrom: "",
      },
      filteredReport: [],
      total:0,
      // SelectOptions:[
      //   {title:'Capital', value:'1'},
      //   {title:'Owners equity', value:'2'},
      //   {title:'Refundable money', value:'3'}
      // ]
    };
  },
  computed: {
      // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapState("accounts", ["cashout"]),
    ...mapGetters("accounts", ["SaveStatus", "CashOut"]),
    ...mapGetters("setting", ["PaymentOptions","GeneralSettings"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    cashout(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCashOut: "accounts/fetchCashout",
      AddCashOut: "accounts/recordCashout",
      EditCashOut: "accounts/editCashout",
      DeleteCashOut: "accounts/deleteCashout",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addComma() {
      this.data.amount = this.thousandSeperator(this.data.amount);
      this.editdata.amount = this.thousandSeperator(this.editdata.amount);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addCashout(modalId) {
      this.modal_id = modalId;

      if (this.data.amount === "") {
        this.amountError = "Amount field is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.mode === "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.AddCashOut(this.data);
    },

    resetAddCash() {
      this.data.amount = "";
      this.data.givento = "";
      this.data.reason = "";
      this.data.mode = "";
      this.modeError = "";
      this.amountError = "";
      this.modal_id = "";
    },
    resetEditCash() {
      this.editdata.amount = "";
      this.editdata.date = "";
      this.editdata.givento = "";
      this.editdata.reason = "";
      this.editdata.id = "";
      this.editdata.mode = "";
      this.modal_id = "";
    },

    resetDeleteCash() {
      this.deletedata.amount = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.modeError = "";
      this.amountError = "";
    },
    showEditModal(data) {
      this.editdata.amount = this.thousandSeperator(data.item.amount);
      this.editdata.givento = data.item.givenTo;
      this.editdata.reason = data.item.reason;
      this.editdata.id = data.item.id;
      this.editdata.date = data.item.date;
      this.editdata.mode = data.item.modeId;
    },

    editCashout(modalId) {
      this.modal_id = modalId;
      this.EditCashOut(this.editdata);
    },

    showDeleteModal(data) {
      this.deletedata.amount = this.thousandSeperator(data.item.amount);
      this.deletedata.id = data.item.id;
    },
    deleteCashOut(modalId) {
      this.modal_id = modalId;
      this.DeleteCashOut(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    assiginData() {
      this.filteredReport = this.CashOut ? this.CashOut : [];
    },

    filterReport() {
      this.filteredReport = this.CashOut.filter((element) => {
        return element.date >= this.filters.dfrom && element.date <= this.filters.dto;
      });
    },
  },

  updated() {
    let total_amount = 0;
      if(this.filteredReport){
        this.filteredReport.forEach((item)=>{
          total_amount = total_amount+parseInt(item.amount);
        });
        this.total = total_amount;
      }
  },

  created() {
    this.FetchCashOut();
    this.FetchModes();
    this.assiginData();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="filters.dfrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="filters.dto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div  v-if="MyUserPerm.add_cash_out == 1 && BranchData.BranchId != 0" class="col-4 mt-4">
                <b-button class="float-end" variant="primary" v-b-modal.add-cashout-modal
                  ><i class="fa fa-plus"></i> Record CashOut</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filteredReport ? filteredReport : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode?data.item.mode:"---" }}
                </template>
                <template #cell(amt_field)="data">
                  {{ data.item.amount?thousandSeperator(data.item.amount):"---" }}
                </template>
                <template #cell(actions)="data">
                  <div>
                    <b-dropdown text="More Actions..." size="sm" class="btn-primary">
                        <b-dropdown-item 
                        v-b-modal.delete-cashout-modal
                    @click="showDeleteModal(data)">
                    <i class="fa fa-trash text-danger"></i> <span v-if="MyUserPerm.delete_cash_out == 1" class="text-danger">Delete</span> 
                    </b-dropdown-item>
                        <b-dropdown-item
                        v-b-modal.edit-cashout-modal
                        @click="showEditModal(data)"
                        ><i class="fa fa-edit text-primary"></i> <span v-if="MyUserPerm.edit_cash_out == 1" class="text-primary">Edit</span>
                        </b-dropdown-item>
                    </b-dropdown>
                    </div>
                </template>
              </b-table>
              <div class="row text-center">
                  <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total)}}</span></h5>
              </div>
            </div>
            <Loader  v-if="!CashOut"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add casin modal starts -->
            <b-modal id="add-cashout-modal" hide-footer @hidden="resetAddCash">
              <template #modal-title> Record New CashOut</template>
              <div class="form-group mb-3">
                <label>Date Given/Sent</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="data.date"
                    @input="resetErrors()"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Amount Given</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.amount"
                    @input="resetErrors()"
                    @keyup="addComma"
                    placeholder="Amount Given"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Given To</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.givento"
                    @input="resetErrors()"
                    placeholder="Given To"
                  />
                </div>
              </div>
              <!-- <div class="form-group mb-3" v-if="GeneralSettings.enable_coa == 1">
                <label>Reason</label>
                <model-list-select
                  :list="SelectOptions ? SelectOptions : []"
                  v-model="data.reason"
                  option-value="value"
                  option-text="title"
                  placeholder="Select Reason"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div> -->
              <div class="form-group mb-3">
                <label>Reason</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.reason"
                    @input="resetErrors()"
                    placeholder="Reason"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Payment Method</label>
                <model-list-select
                  :list="PaymentOptions ? PaymentOptions : []"
                  v-model="data.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="Select Method"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-cashout-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  disabled
                  type="button"
                  class="btn btn-primary">
                  <i class="fa fa-check"></i> Save CashOut
                  <b-spinner                    
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary"
                  @click="addCashout('add-cashout-modal')"
                >
                  <i class="fa fa-check"></i> Save CashOut
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- edit modal starts -->
            <b-modal id="edit-cashout-modal" hide-footer @hidden="resetEditCash">
              <template #modal-title> Edit CashOut of {{ thousandSeperator(editdata.amount) }}</template>
              <div class="form-group mb-3">
                <label>Date Given/Sent</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="editdata.date"
                    @input="resetErrors()"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Amount Given</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editdata.amount"
                    @input="resetErrors()"
                    @keyup="addComma"
                    placeholder="Amount Given"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Given To</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editdata.givento"
                    @input="resetErrors()"
                    placeholder="Given To"
                  />
                </div>
              </div>
              <!-- <div class="form-group mb-3" v-if="GeneralSettings.enable_coa == 1">
                <label>Reason</label>
                <model-list-select
                  :list="SelectOptions ? SelectOptions : []"
                  v-model="editdata.reason"
                  option-value="value"
                  option-text="title"
                  placeholder="Select Reason"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div> -->
              <div class="form-group mb-3">
                <label>Reason</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editdata.reason"
                    @input="resetErrors()"
                    placeholder="Reason"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Payment Method</label>
                <model-list-select
                  :list="PaymentOptions ? PaymentOptions : []"
                  v-model="editdata.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="Select Method"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-cashout-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  disabled
                  type="button"
                  class="btn btn-primary">
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary"
                  @click="editCashout('edit-cashout-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete cashin starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-cashout-modal"
              hide-footer
              @hidden="resetDeleteCash"
            >
              <template #modal-title>
                Delete Cash Out of Amount {{ deletedata.amount }}</template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to delete this record? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-cashout-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  disabled
                  type="button"
                  class="btn btn-danger">
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-danger"
                  @click="deleteCashOut('delete-cashout-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
